import React from 'react';
import { IProps, IState } from 'components/Accordion/Content/types';

class Content extends React.PureComponent<IProps, IState> {
  private contentRef = React.createRef() as React.RefObject<HTMLDivElement>;

  readonly state: IState = {
    contentRefHeight: 0
  }

  componentDidMount () {
    this.setContentElementHeight();
  }

  componentDidUpdate () {
    this.setContentElementHeight();
  }

  // 設置 content element 展開的高度
  setContentElementHeight = () => {
    const contentRefHeight = this.contentRef.current!.clientHeight;
    this.setState(state => ({ ...state, contentRefHeight: contentRefHeight }));
  }

  render () {
    const contentElemHeight = this.props.accordionActive ? this.state.contentRefHeight : 0;
    return (
      <div className="accordion__item-content" style={{ height: contentElemHeight }}>
        <div className="accordion__item-content-wrap" ref={this.contentRef}>
          {this.props.children}
        </div>
      </div>
    );
  }
};

export default Content;
